"use client";

import React from "react";
import { ArrowRight, CircleCheck, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ModernWindowSolutions() {
  const {
    ref: sectionRef,
    isVisible: isSectionVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const colors = ["bg-[hsl(145,15%,45%)]", "bg-[hsl(30,20%,96%)]", "bg-[hsl(210,20%,15%)]", "bg-[hsl(45,30%,60%)]", "bg-[hsl(0,0%,100%)]"];
  return <section data-section-id="227563" id="north-yorks-premier-wellness-hub" className="relative bg-background text-foreground min-h-[100svh] w-full overflow-hidden" ref={sectionRef}>
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[100svh] w-full">
        {}
        <div className="flex flex-col justify-center items-center lg:items-end px-6 py-24 lg:py-12 z-10 order-2 lg:order-1">
          <div className={`w-full max-w-xl lg:pr-16 xl:pr-24 transition-all duration-1000 ease-out ${isSectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <h1 className="font-default text-5xl md:text-6xl lg:text-7xl xl:text-8xl text-primary font-light tracking-tight leading-[1.1] mb-8">North York’s Premier RMT &amp; Facial Wellness&nbsp;</h1>
            <p className="font-default text-lg md:text-xl text-muted-foreground mb-10 leading-relaxed max-w-md font-light">North York's premier RMT and Facial Spa. Steps from Sheppard-Yonge TTC Station, experience clinical precision meets sensory indulgence serving North York and Willowdale communities.</p>
            
            <div className="mb-8">
              
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6">
              <div className="flex flex-col sm:flex-row items-center gap-4">
                <Link to="https://yswellness.noterro.com">
                  <Button size="lg" className="rounded-lg h-14 px-8 text-base tracking-wide shadow-lg hover:shadow-xl transition-all duration-300 group bg-primary text-primary-foreground w-full sm:w-auto">
                    Book Now
                    <ArrowRight className="ml-2 size-5 transition-transform group-hover:translate-x-1" />
                  </Button>
                </Link>
                <Link to="tel:416-938-9900">
                  <Button variant="outline" size="lg" className="rounded-lg h-14 px-8 text-base tracking-wide border-primary/20 hover:border-primary/40 transition-all duration-300 w-full sm:w-auto">Call 416-938-9900</Button>
                </Link>
              </div>
              <div className="flex items-center gap-2 text-sm text-muted-foreground">
                <CircleCheck className="size-4 text-primary/60" />
                <span>Insurance Direct Billing</span>
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="relative h-[50vh] lg:h-auto w-full overflow-hidden order-1 lg:order-2 bg-muted" ref={imageRef}>
          <img data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1653134/img/yonge_sheppard_wellness_interior.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1653134/img/yonge_sheppard_wellness_interior.png-wvc-sizes" alt="Luxury clinical sanctuary interior at Yonge Sheppard RMT" fetchpriority="high" loading="eager" className={`absolute inset-0 w-full h-full object-cover object-center transition-transform duration-[2000ms] ease-out ${isImageVisible ? "scale-100" : "scale-110"}`} src="https://yswellness.ca/wp-content/uploads/2026/07/Grand-Opening-Special-59-Massage-Promo-Not-Eligible-for-Insurance-Starts-Aug-1st-Book-online-today-1.jpg" />

          <div className="absolute inset-0 bg-gradient-to-r from-background/20 to-transparent lg:hidden" />

          <div className={`absolute bottom-6 left-6 lg:bottom-12 lg:-left-16 z-20 transition-all duration-1000 delay-500 ease-out ${isImageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="bg-card/95 backdrop-blur-md p-5 rounded-2xl shadow-2xl border border-border/40 flex flex-col gap-3 min-w-[240px]">
              <div className="flex items-center justify-between gap-4">
                <div className="flex -space-x-2">
                  {colors.map((color, i) => <div key={i} data-index={i} className={`w-7 h-7 rounded-full border-2 border-card shadow-sm ${color}`} aria-label={`Brand palette ${i + 1}`} />)}
                </div>
                <Badge variant="secondary" className="rounded-lg px-3 py-1 text-xs font-medium bg-accent text-accent-foreground">
                  North York, ON
                </Badge>
              </div>
              <div className="space-y-1">
                <p className="text-sm font-default font-semibold text-foreground">
                  Clinical Sanctuary
                </p>
                <p className="text-xs text-muted-foreground">1 Elmhurst Ave&nbsp;</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}